import React, { useEffect, useState } from 'react';
import { IoChevronDown } from 'react-icons/io5';
import '../../../styles/UpdateBets.css';
import "../../../styles/Transaction.css"
import UpdateBetsComponent from './UpdateBetsComponent.tsx';
import { useUser } from '../../../context/UserContext.tsx';
import { Transaction } from '../../../models/User.tsx';
import { betTransaction, getBetTypesByTickets } from '../../../services/player/BetService.tsx';
import { getAdminWeekRangeWeeksAgo } from '../../../helpers/adminWeeklyWeekUtils.tsx';

function getWeekRange(weeksAgo: number) {
  const { start, end } = getAdminWeekRangeWeeksAgo(weeksAgo);
  return { startDate: start, endDate: end };
}

const toTxTime = (createDate: Transaction["createDate"] | Date | string | null | undefined) => {
  if (!createDate) return 0;
  if (createDate instanceof Date) return createDate.getTime();
  if (typeof createDate === "string") {
    const parsed = new Date(createDate).getTime();
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  if (typeof createDate.toDate === "function") return createDate.toDate().getTime();
  if (typeof createDate.seconds === "number") return createDate.seconds * 1000;
  return 0;
};

const UpdateTableComponent = () => {
  const { user } = useUser();

  const [visibleTransactions, setVisibleTransactions] = useState<Transaction[]>([]);
  const [betTypesByTicket, setBetTypesByTicket] = useState<Record<string, string>>({});
  const [selectedWeek, setSelectedWeek] = useState(0);

  const weeks = [
    { label: "This Week", value: 0 },
    { label: "Last Week", value: 1 },
    { label: "2 Weeks Ago", value: 2 },
    ...Array.from({ length: 8 }, (_, i) => ({
      label: `${i + 3} Weeks Ago`,
      value: i + 3,
    })),
  ];


  useEffect(() => {
    let cancelled = false;

    const loadTransaction = async () => {
      if (!user?.userName) return;

      const { startDate, endDate } = getWeekRange(selectedWeek);
      const startMs = startDate.getTime();
      const endMs = endDate.getTime();
      const weekTransactions = await betTransaction(user.userName, startDate, endDate);
      if (cancelled) return;

      const inRange = weekTransactions.filter((tx) => {
        const time = toTxTime(tx.createDate);
        return time >= startMs && time <= endMs;
      });

      setVisibleTransactions(
        [...inRange].sort((a, b) => toTxTime(b.createDate) - toTxTime(a.createDate))
      );
      const types = await getBetTypesByTickets(inRange.map((tx) => tx.ticket));
      if (!cancelled) setBetTypesByTicket(types);
    };

    loadTransaction();
    return () => {
      cancelled = true;
    };
  }, [user, selectedWeek]);


  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedWeek(Number(e.target.value));
  };



  return (
    <div className="tx-history">
      <label className="tx-history__week">
        <select className="tx-history__select" value={selectedWeek} onChange={handleChange} aria-label="Select week">
          {weeks.map(({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
        <IoChevronDown className="tx-history__week-icon" aria-hidden="true" />
      </label>

      <div className="tx-history__list">
        {visibleTransactions.map((tx) => {
          const ticket = tx.ticket != null ? String(tx.ticket).trim() : "";
          return (
            <UpdateBetsComponent key={tx.id} tx={tx} betType={ticket ? betTypesByTicket[ticket] : undefined} />
          );
        })}
      </div>
    </div>
  );
};


export default UpdateTableComponent;
